var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _g, _circle, _line, _circle2, _line2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPumpkinMag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 81,
    viewBox: "0 0 106 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4616 0.527247C37.3479 0.0747134 36.5249 2.1214 35.869 6.63446C35.2131 11.1475 36.1448 15.0188 37.95 15.2811C39.7552 15.5435 41.7504 12.0976 42.4063 7.58457C43.0622 3.07152 43.5753 0.979786 40.4616 0.527247Z",
    fill: "#6A942F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9278,
    cy: 38.5116,
    rx: 16.9278,
    ry: 27.6625,
    fill: "#FC751B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7458,
    cy: 38.5116,
    rx: 16.9278,
    ry: 27.6625,
    fill: "#FC751B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0408,
    cy: 39.3374,
    rx: 16.9278,
    ry: 27.6625,
    fill: "#FC751B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8058 18.6974C22.722 20.8888 20.2315 21.2852 17.733 23.3111C16.8494 24.0275 17.733 25.4946 15.9228 27.467C13.832 28.3412 13.2302 25.7494 11.4316 25.4946C9.36826 25.2023 6.21122 27.0794 5.5486 25.4946C4.30838 22.5283 6.94228 18.6021 11.4316 16.7251C15.9209 14.8481 20.5656 15.7311 21.8058 18.6974Z",
    fill: "#C87749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.537 38.9245C69.4532 41.1159 70.6014 39.7503 69.7551 42.3032C72.6658 44.2919 69.7551 44.4867 67.9449 46.4591C65.8541 47.3332 65.2523 44.7415 63.4537 44.4867C61.3904 44.1944 58.2333 46.0715 57.5707 44.4867C56.3305 41.5204 58.9644 37.5941 63.4537 35.7171C67.943 33.8401 69.3628 34.3829 68.537 38.9245Z",
    fill: "#C87749"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_589)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5215 40.5619C51.1282 36.6385 51.5717 26.8321 49.9777 21.3885L65.9459 22.2091C63.4141 29.2278 64.7692 35.6565 76.4502 42.4081C64.3399 43.5731 33.8042 43.0468 40.5215 40.5619Z",
    fill: "#FEF8E3",
    stroke: "#984B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.531 42.9512C26.6485 40.8192 28.1198 39.0083 30.1706 38.4716L40.3222 35.8145C40.722 35.7099 41.1336 35.6569 41.5467 35.6569H75.6429C76.0954 35.6569 76.5459 35.7204 76.981 35.8458L77.2488 34.9016L76.981 35.8458L85.716 38.3607C87.7592 38.949 89.1884 40.8043 89.2474 42.9451L92.859 173.972C92.9352 176.736 90.7328 179.018 87.9892 179.018H24.1799C21.3831 179.018 19.1605 176.65 19.3156 173.836L26.531 42.9512Z",
    fill: "#FEF8E3",
    stroke: "#984B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.218 22.2369C65.9625 22.2369 73.0513 21.0646 73.0513 19.6185C73.0513 18.1723 65.9625 17 57.218 17C48.4735 17 41.3846 18.1723 41.3846 19.6185C41.3846 21.0646 48.4735 22.2369 57.218 22.2369Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.218 27.4738C65.9625 27.4738 73.0513 26.3014 73.0513 24.8553C73.0513 23.4091 65.9625 22.2368 57.218 22.2368C48.4735 22.2368 41.3846 23.4091 41.3846 24.8553C41.3846 26.3014 48.4735 27.4738 57.218 27.4738Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0513 19.6185H41.3846V24.8555H73.0513V19.6185Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6097 71.7918C25.7134 69.7015 27.4255 68.0603 29.5023 68.0603H84.4464C86.5232 68.0603 88.2353 69.7015 88.339 71.7918L89.8979 103.214C90.0092 105.457 88.2343 107.337 86.0054 107.337H27.9433C25.7144 107.337 23.9394 105.457 24.0507 103.214L25.6097 71.7918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1999 40.959C36.2134 40.959 38.6564 39.7281 38.6564 38.2096C38.6564 36.6912 36.2134 35.4602 33.1999 35.4602C30.1864 35.4602 27.7435 36.6912 27.7435 38.2096C27.7435 39.7281 30.1864 40.959 33.1999 40.959Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2924 40.959C39.5525 40.959 41.3847 39.1126 41.3847 36.8349C41.3847 34.5572 39.5525 32.7108 37.2924 32.7108C35.0323 32.7108 33.2001 34.5572 33.2001 36.8349C33.2001 39.1126 35.0323 40.959 37.2924 40.959Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8358 46.4578C34.096 46.4578 35.9281 44.6114 35.9281 42.3337C35.9281 40.056 34.096 38.2096 31.8358 38.2096C29.5757 38.2096 27.7435 40.056 27.7435 42.3337C27.7435 44.6114 29.5757 46.4578 31.8358 46.4578Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2924 43.7084C39.5525 43.7084 41.3847 42.4774 41.3847 40.959C41.3847 39.4405 39.5525 38.2096 37.2924 38.2096C35.0323 38.2096 33.2001 39.4405 33.2001 40.959C33.2001 42.4774 35.0323 43.7084 37.2924 43.7084Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6667 48.4217C70.8192 48.4217 72.5642 47.5425 72.5642 46.4579C72.5642 45.3733 70.8192 44.494 68.6667 44.494C66.5142 44.494 64.7693 45.3733 64.7693 46.4579C64.7693 47.5425 66.5142 48.4217 68.6667 48.4217Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5897 48.4217C73.2041 48.4217 74.5128 47.1028 74.5128 45.4759C74.5128 43.849 73.2041 42.5302 71.5897 42.5302C69.9753 42.5302 68.6666 43.849 68.6666 45.4759C68.6666 47.1028 69.9753 48.4217 71.5897 48.4217Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6924 52.3495C69.3067 52.3495 70.6154 51.0306 70.6154 49.4037C70.6154 47.7768 69.3067 46.4579 67.6924 46.4579C66.078 46.4579 64.7693 47.7768 64.7693 49.4037C64.7693 51.0306 66.078 52.3495 67.6924 52.3495Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5897 50.3856C73.2041 50.3856 74.5128 49.5063 74.5128 48.4217C74.5128 47.3371 73.2041 46.4579 71.5897 46.4579C69.9753 46.4579 68.6666 47.3371 68.6666 48.4217C68.6666 49.5063 69.9753 50.3856 71.5897 50.3856Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2821 42.5301C47.4346 42.5301 49.1795 41.6509 49.1795 40.5663C49.1795 39.4817 47.4346 38.6024 45.2821 38.6024C43.1296 38.6024 41.3846 39.4817 41.3846 40.5663C41.3846 41.6509 43.1296 42.5301 45.2821 42.5301Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2052 42.5301C49.8196 42.5301 51.1283 41.2112 51.1283 39.5843C51.1283 37.9574 49.8196 36.6385 48.2052 36.6385C46.5908 36.6385 45.2821 37.9574 45.2821 39.5843C45.2821 41.2112 46.5908 42.5301 48.2052 42.5301Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3077 46.4579C45.9221 46.4579 47.2308 45.139 47.2308 43.5121C47.2308 41.8852 45.9221 40.5663 44.3077 40.5663C42.6933 40.5663 41.3846 41.8852 41.3846 43.5121C41.3846 45.139 42.6933 46.4579 44.3077 46.4579Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2052 44.494C49.8196 44.494 51.1283 43.6147 51.1283 42.5301C51.1283 41.4455 49.8196 40.5663 48.2052 40.5663C46.5908 40.5663 45.2821 41.4455 45.2821 42.5301C45.2821 43.6147 46.5908 44.494 48.2052 44.494Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6974 36.2458C86.1414 36.2458 88.9333 34.839 88.9333 33.1036C88.9333 31.3682 86.1414 29.9614 82.6974 29.9614C79.2535 29.9614 76.4615 31.3682 76.4615 33.1036C76.4615 34.839 79.2535 36.2458 82.6974 36.2458Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3743 36.2458C89.9573 36.2458 92.0512 34.1356 92.0512 31.5326C92.0512 28.9295 89.9573 26.8193 87.3743 26.8193C84.7913 26.8193 82.6974 28.9295 82.6974 31.5326C82.6974 34.1356 84.7913 36.2458 87.3743 36.2458Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1385 42.5301C83.7215 42.5301 85.8154 40.42 85.8154 37.8169C85.8154 35.2138 83.7215 33.1036 81.1385 33.1036C78.5555 33.1036 76.4615 35.2138 76.4615 37.8169C76.4615 40.42 78.5555 42.5301 81.1385 42.5301Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3743 39.3879C89.9573 39.3879 92.0512 37.9811 92.0512 36.2457C92.0512 34.5103 89.9573 33.1035 87.3743 33.1035C84.7913 33.1035 82.6974 34.5103 82.6974 36.2457C82.6974 37.9811 84.7913 39.3879 87.3743 39.3879Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5641 44.494C35.1022 44.494 35.5384 44.0544 35.5384 43.5121C35.5384 42.9698 35.1022 42.5302 34.5641 42.5302C34.026 42.5302 33.5897 42.9698 33.5897 43.5121C33.5897 44.0544 34.026 44.494 34.5641 44.494Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0513 42.5301C54.5894 42.5301 55.0256 42.0905 55.0256 41.5482C55.0256 41.0059 54.5894 40.5663 54.0513 40.5663C53.5131 40.5663 53.0769 41.0059 53.0769 41.5482C53.0769 42.0905 53.5131 42.5301 54.0513 42.5301Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1025 46.4579C52.6407 46.4579 53.0769 46.0182 53.0769 45.4759C53.0769 44.9336 52.6407 44.494 52.1025 44.494C51.5644 44.494 51.1282 44.9336 51.1282 45.4759C51.1282 46.0182 51.5644 46.4579 52.1025 46.4579Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2307 44.494C85.7688 44.494 86.2051 44.0544 86.2051 43.5121C86.2051 42.9698 85.7688 42.5302 85.2307 42.5302C84.6926 42.5302 84.2563 42.9698 84.2563 43.5121C84.2563 44.0544 84.6926 44.494 85.2307 44.494Z",
    fill: "#868787"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.71105 94.1633C27.5002 94.1633 44.3531 66.6207 44.3531 32.6452C44.3531 -1.33033 27.5002 -28.8729 6.71105 -28.8729C-14.0781 -28.8729 -30.931 -1.33033 -30.931 32.6452C-30.931 66.6207 -14.0781 94.1633 6.71105 94.1633Z",
    fill: "#FC751B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2881 95.9998C77.0772 95.9998 93.9302 68.4572 93.9302 34.4817C93.9302 0.506212 77.0772 -27.0364 56.2881 -27.0364C35.4989 -27.0364 18.646 0.506212 18.646 34.4817C18.646 68.4572 35.4989 95.9998 56.2881 95.9998Z",
    fill: "#FC751B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4047 33.5635C79.442 38.4369 81.9952 35.3999 80.1133 41.0773C86.5858 45.4999 80.1133 45.9331 76.088 50.3195C71.4387 52.2634 70.1005 46.4998 66.101 45.9331C61.5129 45.2831 54.4925 49.4575 53.0191 45.9331C50.2613 39.3364 56.1182 30.6048 66.101 26.4306C76.0838 22.2564 79.241 23.4635 77.4047 33.5635Z",
    fill: "#C87749"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 38.5,
    r: 31.5,
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 85.4142,
    y1: 60,
    x2: 105,
    y2: 79.5858,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 38.5,
    r: 31.5,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4142,
    y1: 60,
    x2: 105,
    y2: 79.5858,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_589"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 7,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 163,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkinMag);
export default __webpack_public_path__ + "static/media/pumpkin_mag.dfeb6c07edff5d0a806a7f9f7025a278.svg";
export { ForwardRef as ReactComponent };